import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import * as blogStyles from '../blog.module.css';

function SocialLinks() {
   const data = useStaticQuery(graphql`
      query SocialLinksQuery {
         site {
            siteMetadata {
               author {
                  social {
                     title
                     username
                     url
                  }
               }
            }
         }
      }
   `);
   const author = data.site.siteMetadata?.author;
   return (
      <div className={blogStyles.socialWrapper}>
         {author.social.map((social_id, i) => (
            <a
               href={social_id.url + social_id.username}
               target="_blank"
               rel="noreferrer"
               key={i}
            >
               <img
                  src={`/icons/${social_id.title}.png`}
                  alt={social_id.title}
               />
            </a>
         ))}
      </div>
   );
}

export default SocialLinks;
